<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  (onAdd)="onCreate()"
  [class]="isShowResponses ? 'd-none' : ''"
  (sortObject)="getSortItems($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
>
  <!-- before-btns -->
  <div class="card-toolbar" before-btns>
    <!-- refresh btn -->
    <a
      class="btn btn-light txt-lg button-shadow tw-mx-1 text-blue btn-hover-rise d-print-none"
      mat-ripple
      [matTooltip]="'common.refresh' | translate"
      (click)="onReset()"
    >
      <i class="mdi mdi-refresh mdi-20px tw-p-0 text-blue"></i>
    </a>

    <!-- back btn -->
    <a
      class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
      mat-ripple
      [matTooltip]="'common.back' | translate"
      (click)="emitOnBack()"
    >
      <i class="mdi mdi-arrow-left mdi-20px tw-p-0"></i>
    </a>

    <!-- excel btn -->
    <button
      [disabled]="(items$ | async)?.length == 0"
      (click)="onExcelReport()"
      class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
      type="button"
      mat-ripple
      [matTooltip]="'common.downloadExcel' | translate"
    >
      <i class="mdi mdi-download mdi-20px tw-p-0 text-info"></i>
    </button>
  </div>

  <!-------------------------------------- Table Content ----------------------------------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-p-4">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- mobile -->
        <td class="tw-py-3">
          <td-value copyToClipboard [value]="item?.mobile"></td-value>
        </td>

        <!-- mobileOperator -->
        <td>
          <div
            class="tw-flex-center"
            [matTooltip]="
              item?.mobileOperator | enumToText : SmsAggregatorEnumValues
            "
            [mobileOperatorImg]="{
              mobileOperator: item?.mobileOperator,
              mobileOperatorEnumValue:
                item?.mobileOperator | enumToText : SmsAggregatorEnumValues
            }"
          ></div>
        </td>
        <!-- created -->
        <td>
          <td-value type="dateTime" [value]="item?.created"></td-value>
        </td>

        <td class="sticky-td">
          <!-- responses -->
          <a
            (click)="onShowResponses(item?.id)"
            class="btn btn-sm"
            [matTooltip]="'common.responses' | translate"
          >
            <i class="mdi mdi-forum mdi-20px text-info"></i>
          </a>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>
<!-- smartSmsClubFileProgresses -->
<ng-container *ngIf="isShowResponses">
  <app-form-builder-responses-detail
    [responseModel]="responseModel"
    (closePage)="isShowResponses = false"
  >
  </app-form-builder-responses-detail>
</ng-container>
